if (!customElements.get('hoculus-time-output')) {
    class HoculusTimeOutput extends HTMLElement {
        constructor() {
            super();
            this.metaobj = JSON.parse(this.dataset.metaobj);
            this.message = this.metaobj.message;
        }

        connectedCallback() {
            this.updateString();
            this.updateInterval = setInterval(this.updateString.bind(this), 1000);
            if (this.timeDifference > 0) this.classList.remove("d-none");
        }

        updateString() {
            const { days: daysLeft, hours: hoursLeft, minutes: minutesLeft, seconds: secondsLeft } = this.timeUntil();

            // If timer is finished clear interval and hide banner
            if (this.timeDifference > 0) {
                let outputstring = this.message
                    .replace("{dd}", daysLeft)
                    .replace("{hh}", hoursLeft)
                    .replace("{mm}", minutesLeft)
                    .replace("{ss}", secondsLeft);
                this.querySelector("p.offer-string").innerHTML = outputstring;
            } else {
                clearInterval(this.updateInterval);
            }
        }

        timeUntil() {
            const targetDate = new Date(this.metaobj.limit);
            const now = new Date();
            this.timeDifference = targetDate - now;

            let daysRemaining = Math.floor(this.timeDifference / (1000 * 60 * 60 * 24));
            let hoursRemaining = Math.floor((this.timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutesRemaining = Math.floor((this.timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            let secondsRemaining = Math.floor((this.timeDifference % (1000 * 60)) / 1000);

            if (!this.message.includes("{dd}")) hoursRemaining = hoursRemaining + (daysRemaining * 24);
            if (!this.message.includes("{hh}")) minutesRemaining = minutesRemaining + (hoursRemaining * 60);
            if (!this.message.includes("{mm}")) secondsRemaining = secondsRemaining + (minutesRemaining * 60);

            return {
                days: daysRemaining.toString().padStart(2, '0'),
                hours: hoursRemaining.toString().padStart(2, '0'),
                minutes: minutesRemaining.toString().padStart(2, '0'),
                seconds: secondsRemaining.toString().padStart(2, '0')
            };
        }
    }
    customElements.define("hoculus-time-output", HoculusTimeOutput);
}